import { app } from '@/translations/en/app'
import { blockly } from '@/translations/en/blockly'
import { busLogs } from '@/translations/en/busLogs'
import { camera } from '@/translations/en/camera'
import { columns } from '@/translations/en/columns'
import { common } from '@/translations/en/common'
import { roles } from '@/translations/en/common/roles'
import { configuration } from '@/translations/en/configuration'
import { dashboard } from '@/translations/en/dashboard'
import { editor } from '@/translations/en/editor'
import { files } from '@/translations/en/files'
import { finishedConfigurations } from '@/translations/en/finishedConfigurations'
import { flow } from '@/translations/en/flow'
import { groups } from '@/translations/en/groups'
import { login } from '@/translations/en/login'
import { packages } from '@/translations/en/packages'
import { pathway } from '@/translations/en/pathway'
import { profile } from '@/translations/en/profile'
import { users } from '@/translations/en/users'

export const en = {
  app,
  login,
  common,
  users,
  flow,
  columns,
  dashboard,
  configuration,
  editor,
  groups,
  packages,
  files,
  profile,
  roles,
  blockly,
  busLogs,
  pathway,
  camera,
  finishedConfigurations,
}
